import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import StoreService from 'scaleflow/services/store';

class SettingsGroupsListRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.store.findAll('group');
  }
}

export default instrumentRoutePerformance(SettingsGroupsListRoute);
